import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import NavBar from "../NavBar";
import Footer from "../Footer";
import "./LandingPage.css";
import Carousel from "../../Desktop/LandingPage/rcarousel";
import CostEstimate from '../../Common/CostEstimateForm';
import {home_page} from "../../data";
// import CardCarousel from "../../Common/Testimonials";
import { Link } from 'react-router-dom';
import ProjectCard from "../../Common/Tab";
// import CardCarousel from "../../Common/Testimonials";
import CardCarousel from "./testimonial"
import MultiCarousel from "../../Common/LogoCarousel";
import PackageTab from "../../Common/PackageTab";


function App() {
  return <X01LandingPageMobile {...x01LandingPageMobileData} />;
}

export default App;

function X01LandingPageMobile(props) {
  const {
    // line4,
    // line5,
    // line6,
    // line7,
    // line8,
    rectangle72,
    text1,
    spanText,
    spanText2,
    spanText3,
    spanText4,
    spanText5,
    rectangle73,
    text3,
    text4,
    rectangle70,
    text5,
    text6,
    text7,
    whyWebuild,
    rectangle69,
    spanText6,
    spanText7,
    spanText8,
    text9,
    ourProjects,
    text22,
    text23,
    packages,
    costEstimatorBg,
    testimonials,
    text24,
    text19,
    ellipse1,
    name,
    bangaloreIndia,
    image3,
    image4,
    image5,
    getAQuoteButton2Props,
    frame1613Props,
    button22Props,
    packagesCardProps,
    group111Props,
    group112Props,
    group113Props,
    group11422Props,
    estimateNowButtonProps,
    group11722Props,
    estimateNowButtonProps2,
    // group8622Props,
    // group32Props,
    // frame5Props,
    // group87Props,
    //frame145Props,
  } = props;

  return (
    <div className="lpm-container-center-horizontal">
      <div className="lpm-x01-landing-page-mobile lpm-screen" style={{display: 'flex', flexDirection: 'column'}}>
        {/* <div className="lpm-overlap-group" style={{position:'relative', top:'0px', height:'auto'}}> */}
          {/* <div className="lpm-frame-1597"></div> */}
          {/* <div className="lpm-frame-1600" style={{position:'relative', top:'0px', height:'auto'}}> */}
            {/* <div className="lpm-overlap-group1" style={{position:'relative', top:'0px', height:'auto'}}> */}
            <div style={{position:'relative', height:'auto'}}>
            <NavBar/>
            </div>
            <div style={{position:'relative', height:'auto'}}>
            <Carousel />
            </div>
            <div className="lpm-overlap-group2" style={{position:'relative', height:'auto', display: 'flex', flexDirection: 'column',alignItems:'center'}}>
            {/* <div className="lpm-rectangle-71"></div> */}
            <div className="lpm-packages lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{packages}</div>
            <p className="lpm-text-23 lpm-typographybody16-regular">{text23}</p>
            <PackageTab/>
          </div>
          <div className="lpm-cost-estimator-bg" style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center'}}>
              {/* <img className="lpm-cost-estimator-bg" src={costEstimatorBg} /> */}

              <Group11422 costEstimator={group11422Props.costEstimator} text93={group11422Props.text93} />
              <Group11722
                frame12Props={group11722Props.frame12Props}
                frame122Props={group11722Props.frame122Props}
              />
              <EstimateNowButton>{estimateNowButtonProps.children}</EstimateNowButton>
              </div>
              <div id= "whyWebuild" ></div>
          <div style={{position:'relative', height:'auto', display: 'flex', flexDirection: 'column',alignItems:'center',marginTop:'1250px'}}>
            <div className="lpm-why-webuild lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{whyWebuild}</div>
            <p className="lpm-text-7 lpm-typography-body-smalltext-14-regular">{text7}</p>
              <img className="lpm-rectangle-72" src={home_page.WhyWebuild1} alt="The Webuildd Difference" />
              <div className="lpm-text-1 lpm-typographyheadlineh5-extrabold-20">{text1}</div>
              <p className="lpm-text-2 lpm-typographybodysmall-12-regular">
                <span className="lpm-span lpm-typographybodysmall-12-regular">{spanText}</span>
                <span className="lpm-span-1 lpm-typographybodysmall-12-regular">{spanText2}</span>
                <span className="lpm-span2 lpm-overpass-semi-bold-mahogany-12px">{spanText3}</span>
                <span className="lpm-span-1 lpm-typographybodysmall-12-regular">{spanText4}</span>
                <span className="lpm-span lpm-typographybodysmall-12-regular">{spanText5}</span>
              </p>
            
              <img className="lpm-rectangle-73" src={home_page.WhyWebuild2} alt="Webuildd, Minimum Hassles, Maximum Value" />
              <div className="lpm-text-3 lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{text3}</div>
              <p className="lpm-text-4 lpm-typographybodysmall-12-regular">{text4}</p>
             
              <img className="lpm-rectangle-70" src={home_page.WhyWebuild3} alt="Webuildd Customer Value Propositions" />
              <div className="lpm-text-5 lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{text5}</div>
              <p className="lpm-text-6 lpm-typographybodysmall-12-regular">{text6}</p>
           
           
            
          </div>

         <div style={{position:'relative', marginTop:'20px'}}>
         <div className="lpm-group-210">
                <div className="lpm-our-projects lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{ourProjects}
                </div>
                <p className="lpm-text-22 lpm-typography-body-smalltext-14-regular">{text22}</p>
            </div>
         <ProjectCard/>
                {/* <Frame1613 {...frame1613Props} /> */}

                 {/* <Button22 className={button22Props.className}>{button22Props.children}</Button22> */}
          </div>

          

          <div style={{position:'relative', height:'auto', display: 'flex', flexDirection: 'column',alignItems:'center', width:"100%",marginTop:'0px'}}>
            <div className="lpm-testimonials lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24" >{testimonials}</div>
            <p className="lpm-text-24 lpm-typographybody16-regular">{text24}</p>
            {/* <div className="lpm-group-27" >
              <div className="lpm-overlap-group5">
                <p className="lpm-text-19 lpm-typographybodysmall-12-regular">{text19}</p>
                <div className="lpm-group-120">
                  <img className="lpm-ellipse-1" src={ellipse1} />
                  <div className="lpm-group-140">
                    <div className="lpm-name lpm-valign-text-middle lpm-typographyheadlineh5-extrabold-20">{name}</div>
                    <div className="lpm-bangalore-india lpm-valign-text-middle lpm-typographybodysmall-12-regular">
                      {bangaloreIndia}
                    </div>
                  </div>
                </div>
              </div>
            
            </div> */}
            <CardCarousel />
            <Group129 className={estimateNowButtonProps2.className} />
            </div>
            <div className="lpm-overlap-group3" style={{position:'relative',  height:'auto'}}>
              {/* <div className="lpm-rectangle-74">
            
              <img className="lpm-image-3" src={home_page.GreyBG1} />
              <img className="lpm-image-4" src={home_page.GreyBG2} />
              <img className="lpm-image-5" src={home_page.GreyBG3} />
              
            </div> */}
            <MultiCarousel/>
            
          </div>
          <Footer />
          </div>
        </div>
          //   <div>
          // </div>
    //     </div>
    //   </div>
    // </div>
  );
}


function Group129(props) {
  const { className } = props;

  return (
    <div className={`lpm-group-129 ${className || ""}`} >
    </div>
  );
}


// function GetAQuoteButton2(props) {
//   const { children } = props;

//   useEffect(() => {
//     loadTimelineData(x2668579TimelineData);
//   }, []);

//   return (
//     <div className="lpm-x2668579 lpm-component lpm-component-wrapper not-ready">
//       <div className="lpm-master-button-OkO4H7">
//         <div className="lpm-button-i266857951-MlNlfQ lpm-valign-text-middle">{children}</div>
//       </div>
//     </div>
//   );
// }

// const x2668579TimelineData = [
//   {
//     initial_state_name: "Property-1=Primary",
//     root_element: ".lpm-x2668579",
//     states_flow: {
//       "Property-1=Primary": {
//         listeners: [],
//         overrides: {},
//       },
//       "Property-1=Secondary": {
//         listeners: [],
//         overrides: {
//           "": {
//             position: "relative",
//           },
//         },
//       },
//       "Property-1=Tertiary": {
//         listeners: [],
//         overrides: {
//           "": {
//             position: "relative",
//           },
//         },
//       },
//     },
//   },
// ];


function Frame1613(props) {
  // const {
  //   apartments,
  //   buildiings,
  //   group139Props,
  //   frame138Props,
  //   projectCard22Props,
  //   projectCard222Props,
  //   projectCard223Props,
  //   projectCard224Props,
  //   projectCard225Props,
  //   projectCard226Props,
  //   projectCard227Props,
  //   projectCard228Props,
  //   projectCard229Props,
  //   button22Props,
  // } = props;

  return (
    <>
    <div className="lpm-frame-1613" >
   
      <ProjectCard/>
      
    </div>
    
    </>
  );
}


// function Group139(props) {
//   const { children } = props;

//   return (
//     <div className="lpm-group-139">
//       <div className="lpm-overlap-group4">
//         <div className="lpm-rectangle-46"></div>
//         <div className="lpm-price lpm-overpass-extra-bold-shark-14px">{children}</div>
//       </div>
//     </div>
//   );
// }


// function Frame138(props) {
//   const { place, living } = props;

//   return (
//     <div className="lpm-frame-138">
//       <div className="lpm-place lpm-typographybodycaption-14-semi-bold">{place}</div>
//       <div className="lpm-living lpm-typographybodycaption-14-semi-bold">{living}</div>
//     </div>
//   );
// }


// function ProjectCard22(props) {
//   const { rectangle62, text77, surname, className } = props;

//   return (
//     <div className={`lpm-project-card-1 ${className || ""}`}>
//       <img className="lpm-rectangle-62" src={rectangle62} />
//       <div className="lpm-group-99">
//         <div className="lpm-text-1-1 lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{text77}</div>
//         <p className="lpm-surname lpm-typography-body-smalltext-14-regular">{surname}</p>
//       </div>
//     </div>
//   );
// }


function Button22(props) {
  const { children, className } = props;

  useEffect(() => {
    loadTimelineData(x27320746TimelineData);
  }, []);

  return (
    <div className={`lpm-x27320746 lpm-component lpm-component-wrapper not-ready ${className || ""}`} >
      <div className="lpm-master-button-37nz0S">
        <div className="lpm-button-i2732074651-Mmab5X lpm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27320746TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".lpm-x27320746",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function PackagesCard(props) {
  const { basic, group69Props, buttonProps } = props;

  return (
    <div className="lpm-packages-card" >
      <div className="lpm-basic lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{basic}</div>
      <div className="lpm-basic-1">
        {/* <img
          className="lpm-vector"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/basic-1@2x.svg"
        /> */}
        <img
          className="lpm-vector"
          src="../../Images/Home_Page/Img/Icons/Packages/Basic.svg"
        />
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group69(props) {
  const { number, text4 } = props;

  return (
    <div className="lpm-group-69" >
      <h1 className="lpm-number lpm-valign-text-middle lpm-typographyheadlineh2-extrabold-40">{number}</h1>
      <div className="lpm-rs-sft lpm-valign-text-middle lpm-typographybody16-regular">{text4}</div>
    </div>
  );
}


function Button8(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x2668602TimelineData);
  }, []);

  return (
    <div className="lpm-x2668602 lpm-component lpm-component-wrapper not-ready" >
      <div className="lpm-master-button-pOdK04">
        <div className="lpm-button-i266860251-RsTw5N lpm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x2668602TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".lpm-x2668602",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Group1112(props) {
  const { place, overlapGroup4, group69Props, buttonProps } = props;

  return (
    <div className="lpm-packages-card-1" >
      <div className="lpm-place-1 lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{place}</div>
      <div className="lpm-standard">
        <div className="lpm-overlap-group4-1" style={{ backgroundImage: `url(${overlapGroup4})` }}>
        </div>
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group112(props) {
  const { premium, group, vector2, vector3, vector4, group2, group69Props, buttonProps } = props;

  return (
    <div className="lpm-packages-card-2" >
      <div className="lpm-premium lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{premium}</div>
      <div className="lpm-premium-1">
        <div className="lpm-overlap-group4-2">
          <div className="lpm-group" style={{ backgroundImage: `url(${group})` }}></div>
        </div>
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group113(props) {
  const { basic, group69Props, buttonProps } = props;

  return (
    <div className="lpm-packages-card-3" >
      <div className="lpm-basic-2 lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{basic}</div>
      <div className="lpm-luxury">
        <img
          className="lpm-vector-6"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-210@2x.svg"
        />
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group11422(props) {
  const { costEstimator, text93 } = props;

  return (
    <div className="lpm-group-114" >
      <div className="lpm-cost-estimator lpm-valign-text-middle lpm-typographyheadlineh4-extrabold-24">{costEstimator}</div>
      <p className="lpm-text-25 lpm-valign-text-middle lpm-typographybodysmall-12-regular">{text93}</p>
    </div>
  );
}


function EstimateNowButton(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x2668831TimelineData);
  }, []);

  return (
    <div className="lpm-x2668831 lpm-component lpm-component-wrapper not-ready">
      <Link to="/">
        <div className="lpm-master-button-KRtkKN">
          <div className="lpm-button-i266883151-zXi8Hy lpm-valign-text-middle">{children}</div>
        </div>
      </Link>
    </div>
  );
}

const x2668831TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".lpm-x2668831",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
    },
  },
];


function Group11722(props) {
  const { frame12Props, frame122Props } = props;

  return (
    <div className="lpm-group-117">
      <CostEstimate />
      {/* <Frame122>{frame12Props.children}</Frame122>
      <Frame122 className={frame122Props.className}>{frame122Props.children}</Frame122> */}
    </div>
  );
}


function Frame122(props) {
  const { children, className } = props;

  return (
    <div className={`lpm-frame-1 lpm-border-1px-white ${className || ""}`}>
      <div className="lpm-text-26 lpm-inter-normal-white-14px">{children}</div>
    </div>
  );
}


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="lpm-group-86">
      <div className="lpm-white">
        <img
          className="lpm-vector-7"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="lpm-group-85" src={group85} />
    </div>
  );
}


function Group32(props) {
  const { place, overlapGroup4, phone, overlapGroup5, vector2, text21, text20, contactWebuildCom } = props;

  return (
    <div className="lpm-group-32">
      <div className="lpm-place-2 lpm-valign-text-middle lpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="lpm-flex-row-1">
        <div className="lpm-flex-col">
          <div className="lpm-map-pin-1">
            <div className="lpm-overlap-group4-3" style={{ backgroundImage: `url(${overlapGroup4})` }}>
              
            </div>
          </div>
          <div className="lpm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="lpm-mail">
            <div className="lpm-overlap-group5-1" style={{ backgroundImage: `url(${overlapGroup5})` }}>
              <img className="lpm-vector-9" src={vector2} />
            </div>
          </div>
        </div>
        <div className="lpm-flex-col-1">
          <p className="lpm-text-21 lpm-typography-body-smalltext-14-regular">{text21}</p>
          <div className="lpm-flex-col-item lpm-valign-text-middle lpm-typography-body-smalltext-14-regular">{text20}</div>
          <div className="lpm-flex-col-item lpm-valign-text-middle lpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="lpm-frame-5">
      <div className="lpm-quick-links ql-valign-text-start  lpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="lpm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`lpm-frame-140 ${className || ""}`}>
      <div className="lpm-about-us ql-valign-text-start lpm-typographybody16-regular">{aboutUs}</div>
      <div className="lpm-projects ql-valign-text-start lpm-typographybody16-regular">{projects}</div>
    </div>
  );
}


function Group87(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="lpm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram instagram={facebookAppSymbolProps2.instagram} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="lpm-facebook-app-symbol">
      <img className="lpm-f-1" src={src} />
    </div>
  );
}


function Instagram(props) {
  const { instagram, vector2 } = props;

  return (
    <div className="lpm-instagram" style={{ backgroundImage: `url(${instagram})` }}>
      <div className="lpm-overlap-group4-4">
        <img
          className="lpm-vector-10"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="lpm-vector-11" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="lpm-twitter">
      <img className="lpm-vector-12" src={src} />
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="lpm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="lpm-group-86-1">
      <White src={whiteProps.src} />
      <img className="lpm-group-85-1" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="lpm-white-1">
      <img className="lpm-vector-13" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="lpm-icon-menu">
      <img
        className="lpm-vector-15"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="lpm-vector-14" src={vector2} />
      <img className="lpm-vector-14" src={vector3} />
    </div>
  );
}

const getAQuoteButton2Data = {
    children: "GET A QUOTE",
};

const group139Data = {
    children: "ALL",
};

const frame138Data = {
    place: "INTERIOR",
    living: "LIVING",
};

const projectCard22Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-24@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
};

const projectCard222Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-25@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard223Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-26@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard224Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-27@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard225Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-28@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard226Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-29@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard227Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-30@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard228Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-31@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const projectCard229Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-32@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "lpm-project-card",
};

const button22Data = {
    children: "VIEW MORE",
};

const frame1613Data = {
    apartments: "APARTMENTS",
    buildiings: "BUILDIINGS",
    group139Props: group139Data,
    frame138Props: frame138Data,
    projectCard22Props: projectCard22Data,
    projectCard222Props: projectCard222Data,
    projectCard223Props: projectCard223Data,
    projectCard224Props: projectCard224Data,
    projectCard225Props: projectCard225Data,
    projectCard226Props: projectCard226Data,
    projectCard227Props: projectCard227Data,
    projectCard228Props: projectCard228Data,
    projectCard229Props: projectCard229Data,
    button22Props: button22Data,
};

const button222Data = {
    children: "VIEW MORE",
    className: "lpm-x2668590",
};

const group69Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button8Data = {
    children: "VIEW DETAILS",
};

const packagesCardData = {
    basic: "Basic",
    group69Props: group69Data,
    buttonProps: button8Data,
};

const group692Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button82Data = {
    children: "VIEW DETAILS",
};

const group1112Data = {
    place: "Standard",
    //overlapGroup4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/icons@2x.svg",
    overlapGroup4: "../../Images/Home_Page/Img/Icons/Packages/Standard.svg",
    group69Props: group692Data,
    buttonProps: button82Data,
};

const group693Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button83Data = {
    children: "VIEW DETAILS",
};

const group112Data = {
    premium: "Premium",
    //group: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/icons-1@2x.svg",
    group:"../../Images/Home_Page/Img/Icons/Packages/Luxury.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-82@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-207@2x.svg",
    vector4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-208@2x.svg",
    group2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-209@2x.svg",
    group69Props: group693Data,
    buttonProps: button83Data,
};

const group694Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button84Data = {
    children: "VIEW DETAILS",
};

const group113Data = {
    basic: "Luxury",
    group69Props: group694Data,
    buttonProps: button84Data,
};

const group11422Data = {
    costEstimator: "Cost Estimator",
    text93: "Our very own software infused with years of experience. Use it to find a probable cost estimation to help you make a better choice",
};

const estimateNowButtonData = {
    children: "ESTIMATE NOW",
};

const frame122Data = {
    children: "City",
};

const frame1222Data = {
    children: "Area of Construction (Sq.ft)",
    className: "lpm-frame-1-1",
};

const group11722Data = {
    frame12Props: frame122Data,
    frame122Props: frame1222Data,
};

const group1292Data = {
    className: "lpm-group-141",
};

const group8622Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
};

const group32Data = {
    place: "Contact",
    //overlapGroup4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-437@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-214@2x.svg",
    overlapGroup5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-342@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg",
    text21: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text20: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "lpm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "lpm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagramData = {
    instagram: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-223@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-346@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-347@2x.svg",
};

const group87Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagramData,
    twitterProps: twitterData,
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const x01LandingPageMobileData = {
    line4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-8-3@1x.svg",
    rectangle72: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-72@2x.png",
    text1: "The Webuildd Difference",
    spanText: "What makes us stand miles apart from other firms? We call it “Webuildd Difference”: from the very first time you meet us, to the interaction with our team, the hassle-free engagement and finally the day we hand you the keys to your new home/building, the only standard we accept for ourselves (and our customers) is “Consistent Excellence”. We are never satisfied with our laurels, and our service to you goes far beyond simply putting one brick on top of another. We not only ensure that get quality, but also blend it with creativity, engineering, management, quality and multiple other disciplines to deliver the perfect output for your residential or commercial needs. We have even created our very own",
    spanText2: <> <br /></>,
    spanText3: "cost estimator",
    spanText4: " ",
    spanText5: "that helps you calculate your probable capital outgo for your upcoming building. We really like to make things easy for our clients",
    rectangle73: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-73@2x.png",
    text3: "Why Choose Us? Minimum Hassles. Maximum Value",
    text4: "We possess third generation business continuity which is a rarity. Which means that you gain decades of collaborative experience to your benefit. Expertise, quality, transparency, reliability and cost effectiveness are why our customers come back to us again and again. We offer a perfect blend of all these factors resulting in deep customer delight. We put the “Smart” in everything that we do. Smarter design, smarter spaces, smarter value. Simply: smarter living. With exciting options and construction plans to choose from, one is certain to be right for you. Yes, other people do some of what we do, but no one does everything in the unique way we do.",
    rectangle70: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-70@2x.png",
    text5: "Our Customer Value Propositions",
    text6: "When it comes to building a new residential or commercial building, choosing the right partner to bring your vision to life is an important first step. Our experienced Webuildd team has all the expertise, resources, and connections you need to turn inspiration into reality with seamless ease. You don’t have to deal with the hassles of managing complex coordination and multiple resources. Our in-house team has you covered from legal, estimation, site planning, architectural design,",
    text7: "Because we bring to the table over 40 years of comprehensive experience, over 100 happy customers blended with trust, reliability and transparency",
    whyWebuild: "Why Webuildd?",
    rectangle69: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-69-3@2x.png",
    spanText6: <>Gain the Power of “Unified C2C” <br />Unburden yourself while</>,
    spanText7: <> <br /></>,
    spanText8: "we build your future.",
    text9: <>At Webuilld we offer you a completely<br />“Unified Conception to Construction” value proposition.  No more dealing with a dozen sub-contractors or labour hassles when constructing your home or commercial building</>,
    ourProjects: "Our Projects",
    text22: "We offer an entire array of construction options. Choose from basic to luxury according to your requirements",
    text23: "We offer an entire array of construction options. Choose from basic to luxury according to your requirements",
    packages: "Packages",
    costEstimatorBg: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/cost-estimator-bg-1@3x.png",
    testimonials: "Testimonials",
    text24: "Listen to what our customers say about us. They are the beating heart of our business",
    text19: "The whole team was very very supportive and I am really very happy. I am an extremely happy customer, Thank you Webuild !",
    //ellipse1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/ellipse-1-4@2x.png",
    ellipse1:"../../Images/Home_Page/Img/Testimonial/Ellipse-1.png",
    name: "Robert Fox",
    bangaloreIndia: "Bangalore, India",
    image3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-3-2@2x.png",
    image4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-4-2@2x.png",
    image5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-5-2@2x.png",
    getAQuoteButton2Props: getAQuoteButton2Data,
    frame1613Props: frame1613Data,
    button22Props: button222Data,
    packagesCardProps: packagesCardData,
    group111Props: group1112Data,
    group112Props: group112Data,
    group113Props: group113Data,
    group11422Props: group11422Data,
    estimateNowButtonProps: estimateNowButtonData,
    group11722Props: group11722Data,
    estimateNowButtonProps2: group1292Data,
    group8622Props: group8622Data,
    group32Props: group32Data,
    frame5Props: frame5Data,
    group87Props: group87Data,
    frame145Props: frame145Data,
};